import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './GradePage.css';

const Grade11Page = () => {
  return (
    <div className="grade-page">
      <Navbar />
      
      <main className="main-content">
        <div className="grade-hero" style={{ background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)' }}>
          <div className="container">
            <h1>Grade 11 Resources</h1>
            <p>Senior Secondary Level 2 CBC Curriculum Materials</p>
          </div>
        </div>
        
        <div className="container">
          <div className="page-content">
            <h2>Coming Soon - Comprehensive Grade 11 Resources</h2>
            <p>This page is under development and will contain:</p>
            
            <div className="resources-grid">
              <div className="resource-card">
                <h3>Specialized Tracks</h3>
                <p>STEM, humanities, business, and arts</p>
              </div>
              
              <div className="resource-card">
                <h3>Elective Subjects</h3>
                <p>Wide range of elective options</p>
              </div>
              
              <div className="resource-card">
                <h3>Career Guidance</h3>
                <p>Career exploration and planning</p>
              </div>
              
              <div className="resource-card">
                <h3>University Preparation</h3>
                <p>Preparation for higher education</p>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Grade11Page;